import React, { useState, useEffect } from "react";


import DatePickerCustom from "components/Filters/DatePickerCustom";
import { FlexGrid, FlexGridItem } from "components/base/FlexGrid";
import { withTranslation } from "hoc/WithTranslation";
import { useWindowWidth } from "hooks";
import m from "definedMessages";
import { buildDateFilterFormValue, normalizeDateRange } from "./paymentDateUtils";

import { Form } from "rsuite";

/**
 * Shared date-range filter for Payments sections.
 *
 * Props:
 *  - filters          - current filter object with optional `start_end_date`
 *  - onChangeFilters  - called with the updated filter object (including
 *                       normalized `start_date`, `end_date`, `start_end_date`)
 *
 * Controlled internally so the DatePicker always reflects the current state.
 * Falls back to today's day boundaries when no valid range is provided.
 */
const CommonDateFilter = ({ filters, onChangeFilters, formatMessage }) => {
    const resizedWidth = useWindowWidth();

    const [changedFormValue, changeFormData] = useState(() => buildDateFilterFormValue(filters));

    useEffect(() => {
        changeFormData(buildDateFilterFormValue(filters));
    }, [filters]);

    const handleChange = (value) => {
        const normalized = normalizeDateRange(value?.start_end_date);

        if (!normalized) {
            onChangeFilters(value);
            return;
        }

        const [startDate, endDate] = normalized;
        const formData = {
            ...value,
            start_end_date: [startDate, endDate],
            start_date: startDate,
            end_date: endDate,
        };

        onChangeFilters(formData);
        changeFormData(formData);
    };

    return (
        <Form formValue={changedFormValue} onChange={handleChange}>
            <FlexGrid align="middle">
                {resizedWidth > 1005 && (
                    <FlexGridItem>{formatMessage(m.dateFrom)}</FlexGridItem>
                )}
                <FlexGridItem>
                    <DatePickerCustom changedFormValue={changedFormValue} />
                </FlexGridItem>
            </FlexGrid>
        </Form>
    );
};

export default withTranslation(CommonDateFilter);
